






























































































































































































































import { Vue, Component, Ref } from "vue-property-decorator"
import PageHeader from "@/components/page-header/index.vue"
import { openNewViewTab } from "@/utils/index"
import manageService from "@/services/manage.service"
import { FormModel } from "ant-design-vue"
import { NoticeList } from "./constant"
@Component({
    components: {
        PageHeader
    }
})
export default class IterationList extends Vue {
    id: number = null
    product_id: number = null
    detailInfo: any = {}

    currentStep = 0
    tableloading = false

    form: any = {
        product_version_id: "",
        release_desc: "",
        release_time: "",
        cc_uids: []
    }

    batchForm = {
        release_ratio: 100,
        release_scale: 1,
        version_name: ""
    }

    keywords = ""
    selectedRowKeys: number[] = []
    selectRows: any[] = []

    labelCol = { span: 4 }
    wrapperCol = { span: 14 }

    releaseList: any = []
    loading = false

    confirmLoading = false
    batchInfo = {
        type: "",
        visible: false,
        title: ""
    }

    get isIos() {
        return this.detailInfo.product_sub_type === 2
    }

    get columns() {
        const col: any = [
            {
                title: "渠道名称",
                dataIndex: "channel_name",
                key: "channel_name",
                width: 120
            },
            {
                title: "VersionName",
                dataIndex: "version_name",
                key: "version_name",
                width: 320,
                scopedSlots: { customRender: "version_name" }
            },
            {
                title: "发布规模",
                dataIndex: "release_scale",
                key: "release_scale",
                width: 300,
                scopedSlots: { customRender: "release_scale" },
                sorter: (a: any, b: any) => a.release_scale - b.release_scale
            }
        ]
        if (!this.isIos) {
            col.push({
                title: "发布比例",
                dataIndex: "release_ratio",
                key: "release_ratio",
                scopedSlots: { customRender: "release_ratio" },
                sorter: (a: any, b: any) => a.release_ratio - b.release_ratio
            })
        }
        return col
    }

    get rules() {
        return {
            release_ratio: [{ required: true, message: "请输入发布比例", trigger: "blur" }],
            release_scale: [{ required: true, message: "请选择发布规模", trigger: "blur" }],
            version_name: [{ required: true, message: "请输入VersionName", trigger: "blur" }]
        }
    }

    get productName() {
        const { full_name } = this.detailInfo
        return `${full_name || "-"}`
    }

    noticeInfo: any = {}

    get noticeList() {
        return NoticeList
    }

    async created() {
        this.id = Number(this.$route.query.id)
        this.product_id = Number(this.$route.query.product_id)
        this.tableloading = true
        await this.getDetail()
        this.getLaunchList()
    }

    nextCheck() {
        if (!this.selectRows.length) {
            this.$message.warning("请先选择需要批量操作的渠道！")
        }
    }
    checkSelectRow() {
        if (!this.selectRows.length) {
            return "请先选择需要发布的渠道！"
        }
        const isRatioZero = this.selectRows.some(item => item.release_ratio === 0)
        if (isRatioZero) {
            return "选择的渠道发布比例必须大于0！"
        }
        return false
    }

    changeStep(step: number) {
        const selectMsg = this.checkSelectRow()
        if (this.currentStep === 0 && step > 0 && selectMsg) {
            this.$message.warning(selectMsg)
            return
        }
        this.currentStep = this.currentStep + step
        if (this.currentStep === 2) {
            this.getMemberInfo()
        }
    }

    onSelectChange(selectedRowKeys: any, selectedRows: any) {
        this.selectRows = selectedRows
        this.selectedRowKeys = selectedRowKeys
    }

    batchSet(type: string) {
        if (!this.selectRows.length) {
            this.$message.warning("请先选择需要批量操作的渠道！")
            return
        }
        this.batchInfo = {
            type,
            visible: true,
            title: type === "version" ? "批量发布版本设置" : "批量发布比例设置"
        }
    }

    @Ref("batchForm")
    refFrom: FormModel

    async operateBatch() {
        try {
            await this.refFrom.validate()
            this.releaseList.forEach((item: any) => {
                const { release_ratio, release_scale, version_name } = this.batchForm
                if (this.selectedRowKeys.includes(item.id)) {
                    if (this.batchInfo.type === "version") {
                        item.version_name = version_name
                    } else {
                        item.release_ratio = release_ratio
                        item.release_scale = release_scale
                    }
                }
            })
            this.batchInfo.visible = false
        } catch (error) {
            if (error) {
                this.$message.error(`${error}`)
            }
        }
    }

    goBack() {
        this.$router.go(-1)
    }

    openLink(url: string) {
        if (!url) {
            return
        }
        openNewViewTab(url)
    }

    changeScale(record: any) {
        if (record.release_scale === 1) {
            record.release_ratio = 100
        } else {
            record.release_ratio = this.isIos ? 1 : 0
        }
    }

    async getDetail() {
        try {
            const res: any = await manageService.getVersionDetail({
                product_version_id: this.id
            })
            this.detailInfo = res || {}
        } catch (error) {
            this.$message.error(`${error},获取详情失败！`)
        }
    }

    async getMemberInfo() {
        try {
            const res = await manageService.getMemberInfo({
                product_id: this.detailInfo.product_id,
                software_id: this.detailInfo.software_id
            })
            this.noticeInfo = res || {}
        } catch (error) {
            this.$message.error(`${error}`)
        }
    }

    async getLaunchList() {
        this.tableloading = true
        try {
            const res: any = await manageService.getLaunchList({
                product_version_id: this.id,
                keywords: this.keywords
            })
            const { list = [] } = res || {}
            if (this.isIos) {
                this.releaseList = list.map((item: any) => {
                    if (item.release_scale === 2 && item.release_ratio === 0) {
                        item.release_ratio = 1
                    }
                    return item
                })
            } else {
                this.releaseList = list
            }
        } catch (error) {
            this.$message.error(`${error},获取列表失败！`)
        } finally {
            this.tableloading = false
        }
    }

    submit() {
        this.$confirm({
            title: "请确认是否进行发布？",
            onOk: () => {
                this.releaseVersion()
            }
        })
    }

    async releaseVersion() {
        try {
            this.loading = true
            await manageService.releaseVersion({
                ...this.form,
                list: this.selectRows,
                product_version_id: this.id
            })
            this.$message.success(`发布成功！`)
            window.history.go(-1)
        } catch (error) {
            this.$message.error(`${error}`)
        } finally {
            this.loading = false
        }
    }
}
